import React, { ReactElement, memo } from "react";

import useMediaQuery from "@services/breakpoint.hooks";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { HuboModal } from "@components/General/HuboModal/huboModal.component";

import { StorePicker, StorePickerConfig } from "./storePicker.container";

type StorePickerModalProps = StorePickerConfig & {
    isOpen: boolean;
    titleTK?: string;
    subTitleTK?: string;
};

const _StorePickerModal = ({
    isOpen,
    titleTK,
    subTitleTK,
    ...storePickerProps
}: StorePickerModalProps): ReactElement => {
    const { t } = useGranite();
    const isSmallScreen = useMediaQuery("screen and (max-height: 530px)");
    const title = t(titleTK || "general.storePicker.modal.title");

    return (
        <HuboModal
            className={"store-picker-context"}
            modalState={isOpen}
            autoFocus={false}
            toggleHandler={() => storePickerProps.onClose?.()}
            size="sm"
            title={title}
            subtitle={subTitleTK && t(subTitleTK)}
            withFooter={false}
            backdrop={true}
            scrollable={!isSmallScreen}
            centered={!isSmallScreen}
        >
            <StorePicker {...storePickerProps} disabled={!isOpen} />
        </HuboModal>
    );
};

export const StorePickerModal = memo(_StorePickerModal);
